<script>
export default {
  name: 'MvDialog',
  props: {
    header: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50%'
    },
    customBodyStyle: {
      type: [String, Object],
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    },
    borderRadius: {
      type: String,
      default: '10px'
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    maxContentHeight: {
      type: String,
      default: '60vh'
    }
  },
  data() {
    return {
      innerVisible: this.visible,
      scrollPosition: 0
    }
  },
  watch: {
    visible(val) {
      this.innerVisible = val
      this.handleBody()
    }
  },
  methods: {
    handleClick() {
      if (this.closeOnClickModal) {
        this.close()
      }
    },
    handleHeaderClick() {

    },
    handleContentClick() {

    },
    handleBody() {
      if (this.innerVisible) {
        // 显示弹窗时禁止背景滚动
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
        document.body.classList.add('no-scroll')
        document.body.style.top = `-${this.scrollPosition}px`
      } else {
        // 隐藏弹窗时恢复背景滚动
        document.body.classList.remove('no-scroll')
        window.scrollTo(0, this.scrollPosition)
      }
    },
    open() {
      this.innerVisible = true
      this.$emit('open')
      this.updateVisible()
    },
    close() {
      this.innerVisible = false
      this.$emit('close')
      this.updateVisible()
    },
    updateVisible() {
      this.$emit('update:visible', this.innerVisible)
      this.handleChange()
      this.handleBody()
    },
    handleChange() {
      this.$emit('change', this.innerVisible)
    }
  }
}
</script>

<template>
  <transition appear>
    <div v-if="innerVisible" class="mv-dialog" @click="handleClick">
      <div
        class="mv-dialog__container"
        :style="{
          width: width,
          borderRadius: borderRadius
        }"
      >
        <div v-if="header" class="mv-dialog__header" @click.stop="handleHeaderClick">
          <slot name="header">
            <div class="mv-dialog__title">{{ title }}</div>
          </slot>
          <div v-if="showClose" class="mv-dialog__close" @click="close">
            <img :src="require('@/assets/close.png')">
          </div>
        </div>
        <div
          class="mv-dialog__body"
          :style="[
            {
              maxHeight: maxContentHeight,
              overflow: 'auto'
            },
            customBodyStyle
          ]"
          @click.stop="handleContentClick"
        >
          <slot />
        </div>
        <div class="mv-dialog__footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>
<style>
/* 禁止body滚动时的样式 */
body.no-scroll {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}
</style>
<style scoped lang="scss">
.mv-dialog {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;

  &__container {
    background-color: white;
    border-radius: 10px;
  }

  &__header {
    padding: 20px 40px 20px 20px;
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
  }

  &__body {
    padding: 20px;
  }

  &__close {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 20px;
    cursor: pointer;
    overflow: hidden;

    img {
      width: 20px;
      height: 20px;
    }
  }

}
</style>
